import colors from '../../tokens/colors'
import borderV2 from '../../tokens/v2/border'
import border from '../../tokens/border'
import colorsV2 from '../../tokens/v2/colors'
import layout from '../../tokens/layout'
import typography from '../../tokens/typography'
import { Theme } from '../../components/theme-provider'
import layoutV2 from '../../tokens/v2/layout'
import typographyV2 from '../../tokens/v2/typography'

export const defaultTheme: Theme = {
  theme: {
    autoComplete: {
      background: colors.neutralColorHighPure,
      borderColor: colors.neutralColorLowLight,
      borderRadius: borderV2.radius.micro,
      borderWidth: borderV2.width.micro,
      color: colors.neutralColorLowPure,
      disabledBackground: colors.neutralColorHighLight,
      disabledBorderColor: colors.neutralColorLowLight,
      fontHeight: typographyV2.fontHeight.medium,
      fontSize: typographyV2.fontSize.small,
      iconColor: 'inherit',
      iconPadding: layoutV2.spacing.xxxs,
      optionColor: colors.neutralColorLowPure,
      optionFontSize: typographyV2.fontSize.small,
      paddingBotton: layoutV2.spacing.xmc,
      paddingLeft: layoutV2.spacing.xxxs,
      paddingRight: layoutV2.spacing.md,
      paddingTop: layoutV2.spacing.xmc,
      placeholderColor: colors.neutralColorLowMedium,
      prefixColor: colors.neutralColorLowPure,
    },
    brandColors: {
      primaryDark: colors.brandColorPrimaryDark,
      primaryLight: colors.brandColorPrimaryLight,
      primaryMedium: colors.brandColorPrimaryMedium,
      primaryPure: colors.brandColorPrimaryPure,
      sideMenuDividerColor: colors.neutralColorHighDark,
      sideMenuFontColor: colors.neutralColorLowPure,
      sideMenuBackgroundColor: colors.neutralColorHighPure,
    },
    breadcrumbs: {
      activeBackgroundColor: colorsV2.gray100,
      activeBorderRadius: borderV2.radius.micro,
      activeColor: colorsV2.black,
      activePadding: `${layoutV2.spacing.xxmc} ${layoutV2.spacing.xmc}`,
      backgroundColor: colorsV2.white,
      borderRadius: borderV2.radius.none,
      color: colorsV2.gray500,
      fontSize: typographyV2.fontSize.small,
      fontWeight: typographyV2.fontWeight.medium,
      padding: `${layoutV2.spacing.xxmc} ${layoutV2.spacing.none}`,
    },
    button: {
      loadingBorderColor: colors.neutralColorLowLight,
      loadingBorderRightColor: colors.brandColorPrimaryPure,
      borderRadius: borderV2.radius.medium,
      dangerActiveBackgroundColor: colors.feedbackColorNegativeDark,
      dangerBackgroundColor: colors.feedbackColorNegativePure,
      dangerBorder: '',
      dangerColor: colors.neutralColorHighPure,
      dangerDisabledBackgroundColor: colors.neutralColorHighMedium,
      dangerDisabledBorder: '',
      dangerDisabledColor: colors.neutralColorLowMedium,
      dangerFocusOutline: `${border.width.widthThin} solid ${colors.neutralColorLowPure}`,
      dangerFocusShadow: '',
      dangerHoverBackgroundColor: colors.feedbackColorNegativeMedium,
      dangerHoverColor: '',
      dangerHoverShadow: '',
      dangerLoadingBorderColor: colors.feedbackColorNegativeDark,
      dangerLoadingBorderRightColor: colors.neutralColorHighPure,
      fontSize: typographyV2.fontSize.small,
      fontStyle: 'normal',
      fontWeight: typographyV2.fontWeight.semiBold,
      height: '4rem',
      paddingBottom: layoutV2.spacing.xmc,
      paddingLeft: layoutV2.spacing.xxxs,
      paddingRight: layoutV2.spacing.xxxs,
      paddingTop: layoutV2.spacing.xmc,
      positiveActiveBackgroundColor: colors.feedbackColorPositiveDark,
      positiveBackgroundColor: colors.feedbackColorPositivePure,
      positiveBorder: '',
      positiveColor: colors.neutralColorHighPure,
      positiveDisabledBackgroundColor: colors.neutralColorHighMedium,
      positiveDisabledBorder: '',
      positiveDisabledColor: colors.neutralColorLowMedium,
      positiveFocusOutline: `${border.width.widthThin} solid ${colors.neutralColorLowPure}`,
      positiveFocusShadow: '',
      positiveHoverBackgroundColor: colors.feedbackColorPositiveMedium,
      positiveHoverColor: '',
      positiveHoverShadow: '',
      positiveLoadingBorderColor: colors.feedbackColorPositiveDark,
      positiveLoadingBorderRightColor: colors.neutralColorHighPure,
      primaryActiveBackgroundColor: '',
      primaryBackgroundColor: '',
      primaryBorder: '',
      primaryColor: colors.neutralColorHighPure,
      primaryDisabledBackgroundColor: colors.neutralColorHighMedium,
      primaryDisabledBorder: '',
      primaryDisabledColor: colors.neutralColorLowMedium,
      primaryFocusOutline: `${border.width.widthThin} solid ${colors.neutralColorLowPure}`,
      primaryFocusShadow: '',
      primaryHoverBackgroundColor: '',
      primaryHoverColor: '',
      primaryHoverShadow: '',
      pimaryLoadingBorderColor: colors.brandColorPrimaryDark,
      pimaryLoadingBorderRightColor: colors.neutralColorHighPure,
      secondaryActiveBackgroundColor: colors.neutralColorHighDark,
      secondaryBackgroundColor: 'transparent',
      secondaryBorder: `${border.width.widthThin} solid ${colors.neutralColorLowLight}`,
      secondaryColor: colors.neutralColorLowPure,
      secondaryDisabledBackgroundColor: colors.neutralColorHighMedium,
      secondaryDisabledBorder: '',
      secondaryDisabledColor: colors.neutralColorLowMedium,
      secondaryFocusOutline: `${border.width.widthThin} solid ${colors.neutralColorLowPure}`,
      secondaryFocusShadow: '',
      secondaryHoverBackgroundColor: colors.neutralColorHighMedium,
      secondaryHoverColor: '',
      secondaryHoverShadow: '',
      secondaryLoadingBorderColor: colors.brandColorSecondaryDark,
      secondaryLoadingBorderRightColor: colors.brandColorPrimaryPure,
      tertiaryActiveBackgroundColor: colors.neutralColorHighDark,
      tertiaryBackgroundColor: 'transparent',
      tertiaryBorder: '',
      tertiaryColor: colors.neutralColorLowPure,
      tertiaryDisabledBackgroundColor: 'transparent',
      tertiaryDisabledBorder: '',
      tertiaryDisabledColor: colors.neutralColorLowMedium,
      tertiaryFocusOutline: `${border.width.widthThin} solid ${colors.neutralColorLowPure}`,
      tertiaryFocusShadow: '',
      tertiaryHoverBackgroundColor: colors.neutralColorHighMedium,
      tertiaryHoverColor: '',
      tertiaryHoverShadow: '',
      tertiaryLoadingBorderColor: colors.neutralColorLowLight,
      tertiaryLoadingBorderRightColor: colors.brandColorPrimaryPure,
    },
    checkbox: {
      background: 'transparent',
      borderColor: colors.neutralColorLowLight,
      borderColorSelected: 'none',
      borderRadius: borderV2.radius.micro,
      borderWidth: borderV2.width.micro,
      marginRight: layoutV2.spacing.xxxs,
      selectedColor: colors.neutralColorHighPure,
      backgroundSelected: '',
    },
    collapseCard: {
      border: `${borderV2.width.nano} solid ${colors.neutralColorHighDark}`,
      borderRadius: borderV2.radius.micro,
      backgroundColor: colors.neutralColorHighPure,
      titleColor: colors.neutralColorLowDark,
      descriptionColor: colors.neutralColorLowDark,
      fontWeightDescription: typographyV2.fontWeight.regular,
      fontWeightTitle: typographyV2.fontWeight.semiBold,
      fontSizeTitle: typographyV2.fontSize.small,
      fontSizeDescription: typographyV2.fontSize.small,
      width: '5rem',
    },
    hint: {
      color: colors.neutralColorLowMedium,
      fontSize: typographyV2.fontSize.micro,
      fontWeight: typographyV2.fontWeight.regular,
      marginBottom: layoutV2.spacing.none,
      paddingTop: layoutV2.spacing.xmc,
      marginTop: '-2.6rem',
      negativeColor: colors.feedbackColorNegativePure,
    },
    input: {
      background: colors.neutralColorHighPure,
      borderColor: colors.neutralColorLowLight,
      borderRadius: borderV2.radius.micro,
      borderWidth: borderV2.width.micro,
      color: colors.neutralColorLowPure,
      fontHeight: 'inherit',
      fontSize: typographyV2.fontSize.small,
      iconColor: 'inherit',
      iconPadding: layoutV2.spacing.xxxs,
      paddingBotton: layoutV2.spacing.xmc,
      paddingLeft: layoutV2.spacing.xxxs,
      paddingRight: layoutV2.spacing.md,
      paddingTop: layoutV2.spacing.xmc,
      placeholderColor: colors.neutralColorLowMedium,
      prefixColor: colors.neutralColorLowPure,
      negativeBorderColor: colors.feedbackColorNegativePure,
      negativeBackgroundColor: colors.feedbackColorNegativeLight,
    },
    inputLabel: {
      color: colors.neutralColorLowPure,
      fontSize: typographyV2.fontSize.small,
      fontWeight: typographyV2.fontWeight.semiBold,
      fontHeight: typographyV2.fontHeight.small,
      marginBottom: layoutV2.spacing.xmc,
    },
    textareaHint: {
      color: colors.neutralColorLowMedium,
      fontSize: typography.fontSize.fontSizeXxs,
      fontWeight: typographyV2.fontWeight.regular,
      marginTop: layout.margin.spacingNano,
    },
    navbar: {
      backgroundColor: colors.neutralColorHighPure,
      border: `${borderV2.width.nano} solid ${colors.neutralColorHighDark}`,
      marginLeft: '14.2rem',
      marginRight: '14.2rem',
      height: '6.8rem',
      menuItemColor: colors.neutralColorLowPure,
      menuItemFocusColor: colors.brandColorPrimaryPure,
      menuItemFontSize: typographyV2.fontSize.micro,
      menuItemFontWeght: typographyV2.fontWeight.regular,
      menuItemHeight: '4.8rem',
      menuItemHoverBackgroundColor: colors.neutralColorHighMedium,
      menuItemHoverBorderRadius: borderV2.radius.micro,
      menuItemHoverColor: colors.brandColorPrimaryPure,
      menuItemIconColor: '',
      menuItemIconHoverColor: colors.neutralColorLowMedium,
      menuItemMargin: layoutV2.spacing.none,
      menuItemNotificationColor: colors.brandColorPrimaryPure,
      menuItemNotificationLeft: '2.87rem',
      menuItemNotificationSize: '0.8rem',
      menuItemNotificationTop: '2.5rem',
      menuItemPadding: `${layoutV2.spacing.none} ${layoutV2.spacing.xxxs}`,
      menuItemPictureSize: '3.2rem',
      menuItemTextAlign: 'right',
      menuItemTextFontWeight: typographyV2.fontWeight.semiBold,
      menuItemTextMarginRight: layoutV2.spacing.xxxs,
      menuItemWidth: 'auto',
      padding: layoutV2.spacing.none,
      submenuBackgoundColor: colors.neutralColorHighPure,
      submenuBorder: `${borderV2.width.nano} solid ${colors.neutralColorHighDark}`,
      submenuBorderRadius: borderV2.radius.medium,
      submenuBoxShadow: '0 0.4rem 1.6rem rgba(0, 0, 0, 0.08)',
      subitemColor: colors.neutralColorLowPure,
      subitemFontHeight: 'normal',
      subitemFontSize: typographyV2.fontSize.small,
      subitemFontWeight: typographyV2.fontWeight.semiBold,
      subitemHoverColor: colors.brandColorPrimaryPure,
      subitemMarginBottom: '2rem',
      submenuPadding: layoutV2.spacing.xxxs,
      submenuRight: '0.8rem',
      submenuTextMarginLeft: layoutV2.spacing.xmc,
      submenuTop: '6.4rem',
      logoHeight: '4rem',
      logoWidth: '4.8rem',
    },
    numericInput: {
      borderColor: colors.neutralColorLowLight,
      borderRadius: borderV2.radius.medium,
      borderWidth: borderV2.width.micro,
      displayBorderColor: colors.neutralColorLowLight,
      displayBorderWidth: borderV2.width.micro,
      displayWidth: '9rem',
    },
    paginationTableAlt: {
      backgroundColor: colorsV2.white,
      borderRadius: `${border.radius.radiusNone} ${border.radius.radiusNone} ${borderV2.radius.medium} ${borderV2.radius.medium}`,
      border: `${borderV2.width.nano} solid ${colorsV2.gray200}`,
      padding: `${layoutV2.spacing.micro} ${layoutV2.spacing.xs} ${layoutV2.spacing.xs} ${layoutV2.spacing.xxxs}`,
      buttonColor: colorsV2.gray700,
      fontWeight: typographyV2.fontWeight.medium,
      buttonBackgroundColor: colorsV2.white,
      buttonBorder: `${borderV2.width.nano} solid ${colorsV2.gray300}`,
      buttonBorderRadius: borderV2.radius.medium,
      buttonPadding: `${layoutV2.spacing.xmc} ${layoutV2.spacing.xxxs}`,
      buttonHoverBackgroundColor: colorsV2.gray50,
      buttonHoverColor: colorsV2.gray800,
      buttonFocusBackgroundColor: colorsV2.white,
      buttonFocusColor: colorsV2.gray700,
      buttonFocusShadow: `0 0 0 0.4rem ${colorsV2.gray100}, 0 0.1rem 0.2rem 0 rgba(16, 24, 40, 0.05)`,
      buttonDisabledColor: colorsV2.gray300,
      buttonDisabledBackgroundColor: colorsV2.white,
      buttonDisabledBorderColor: colorsV2.gray200,
      buttonPageColor: colorsV2.gray700,
      buttonPageBorder: `${borderV2.width.nano} solid ${colorsV2.gray300}`,
      buttonPageBorderRadius: borderV2.radius.medium,
      buttonPageBackgroundColor: colorsV2.gray50,
    },
    radioButton: {
      background: 'transparent',
      borderColor: colors.neutralColorLowLight,
      borderWidth: borderV2.width.micro,
      marginRight: layoutV2.spacing.xmc,
      radioIconSize: '1rem',
      selectedBackground: 'transparent',
      size: '2rem',
    },
    sideMenuAlt: {
      activeBackground: colorsV2.gray200,
      activeBorderRadius: borderV2.radius.small,
      activeColor: colorsV2.gray900,
      activeFontWeight: typographyV2.fontWeight.semiBold,
      announcementBackground: colorsV2.gray100,
      announcementColor: colorsV2.gray500,
      announcementTitleColor: colorsV2.gray900,
      background: colorsV2.gray50,
      borderColor: colorsV2.gray200,
      borderWidth: borderV2.width.nano,
      color: colorsV2.gray700,
      iconColor: colorsV2.gray600,
      iconFontSize: typographyV2.fontSize.xXLarge,
      imageIconHeight: 'auto',
      imageIconWidth: '4.8rem',
      imageHeight: '6.0rem',
      imageMargin: `${layoutV2.spacing.none} ${layoutV2.spacing.none} ${layoutV2.spacing.sm} ${layoutV2.spacing.none}`,
      imagePadding: `${layoutV2.spacing.none} ${layoutV2.spacing.none} ${layoutV2.spacing.none} ${layoutV2.spacing.xxmc}`,
      imageWidth: 'auto',
      fontSize: typographyV2.fontSize.medium,
      fontWeight: typographyV2.fontWeight.medium,
      height: '95rem',
      notificationBorderColor: colorsV2.white,
      notificationColor: colors.brandColorPrimaryPure,
      notificationSize: '0.8rem',
      paddingBottom: layoutV2.spacing.xs,
      paddingLeft: layoutV2.spacing.xxxs,
      paddingRight: layoutV2.spacing.xxxs,
      paddingTop: layoutV2.spacing.sm,
      sectionColor: colorsV2.gray500,
      sectionFontSize: typographyV2.fontSize.micro,
      sectionWeight: typographyV2.fontWeight.semiBold,
      sectionLineHeight: typographyV2.fontHeight.micro,
      width: '24.8rem',
    },
    snackbar: {
      actionButton: {
        border: borderV2.width.none,
        borderRadius: borderV2.radius.display,
        fontHeight: typographyV2.fontHeight.micro,
        fontSize: typographyV2.fontSize.small,
        fontWeight: typographyV2.fontWeight.semiBold,
        marginLeft: layoutV2.spacing.xxxs,
        padding: layoutV2.spacing.micro,
      },
      border: `${borderV2.width.micro} solid`,
      borderRadius: borderV2.radius.micro,
      boxShadow: '0 0.4rem 1.6rem rgba(0, 0, 0, 0.08)',
      closeButtonMarginLeft: layoutV2.spacing.xxxs,
      fontHeight: typographyV2.fontHeight.micro,
      fontSize: typographyV2.fontSize.small,
      fontWeight: typographyV2.fontWeight.semiBold,
      neutralColor: {
        highPriority: {
          actionButtonBackgroundColor: colors.feedbackColorInfoDark,
          actionButtonColor: colors.neutralColorHighPure,
          backgroundColor: colors.feedbackColorInfoPure,
          borderColor: colors.feedbackColorInfoPure,
          color: colors.neutralColorHighPure,
        },
        lowPriority: {
          actionButtonBackgroundColor: '#bee0ff',
          actionButtonColor: colors.feedbackColorInfoPure,
          backgroundColor: colors.feedbackColorInfoLight,
          border: `${borderV2.width.micro} solid`,
          color: colors.feedbackColorInfoPure,
        },
      },
      negativeColor: {
        highPriority: {
          actionButtonBackgroundColor: colors.feedbackColorNegativeDark,
          actionButtonColor: colors.neutralColorHighPure,
          backgroundColor: colors.feedbackColorNegativePure,
          borderColor: colors.feedbackColorNegativePure,
          color: colors.neutralColorHighPure,
        },
        lowPriority: {
          actionButtonBackgroundColor: '#ffcdd1',
          actionButtonColor: colors.feedbackColorNegativePure,
          backgroundColor: colors.feedbackColorNegativeLight,
          border: `${borderV2.width.micro} solid`,
          color: colors.feedbackColorNegativePure,
        },
      },
      padding: layoutV2.spacing.micro,
      positiveColor: {
        highPriority: {
          actionButtonBackgroundColor: colors.feedbackColorPositiveMedium,
          actionButtonColor: colors.neutralColorHighPure,
          backgroundColor: colors.feedbackColorPositivePure,
          borderColor: colors.feedbackColorPositivePure,
          color: colors.neutralColorHighPure,
        },
        lowPriority: {
          actionButtonBackgroundColor: '#c5ecc0',
          actionButtonColor: colors.feedbackColorPositivePure,
          backgroundColor: colors.feedbackColorPositiveLight,
          border: `${borderV2.width.micro} solid`,
          color: colors.feedbackColorPositivePure,
        },
      },
      position: {
        bottom: '4rem',
        left: '4rem',
        right: 'inherit',
        top: 'inherit',
      },
      textMarginLeft: layoutV2.spacing.xxxs,
      textMaxWidth: '40rem',
      warningColor: {
        highPriority: {
          actionButtonBackgroundColor: colors.feedbackColorWarningMedium,
          actionButtonColor: colors.neutralColorLowPure,
          backgroundColor: colors.feedbackColorWarningPure,
          borderColor: colors.feedbackColorWarningPure,
          color: colors.neutralColorLowPure,
        },
        lowPriority: {
          actionButtonBackgroundColor: '#ffe3cf',
          actionButtonColor: colors.feedbackColorWarningDark,
          backgroundColor: colors.feedbackColorWarningLight,
          border: `${borderV2.width.micro} solid`,
          color: colors.feedbackColorWarningDark,
        },
      },
    },
    switch: {
      backgroundColor: colors.neutralColorLowLight,
      borderRadius: borderV2.radius.display,
      checkedBackgroundColor: '',
      disabledBackgroundColor: colors.neutralColorHighLight,
      disabledBorder: `${borderV2.width.micro} solid ${colors.neutralColorLowLight}`,
      height: '2.4rem',
      hoverBackgroundColor: '',
      focusShadow: '',
      sliderBackgroundColor: colors.neutralColorHighPure,
      sliderDisabledBackgroundColor: colors.neutralColorLowLight,
      sliderHeight: '2rem',
      sliderShadow: '',
      sliderTransform: '1.4rem',
      sliderWidth: '2rem',
      width: '3.8rem',
    },
    table: {
      borderColor: '',
      borderRadius: '',
      borderStyle: '',
      borderWidth: '',
      color: colors.neutralColorLowPure,
      fontHeight: typographyV2.fontHeight.small,
      fontSize: typographyV2.fontSize.small,
      fontWeight: typographyV2.fontWeight.regular,
      headerBackground: colors.neutralColorHighMedium,
      headerBorderColor: colors.neutralColorLowLight,
      headerBorderWidth: '',
      headerColor: colors.neutralColorLowDark,
      headerFontHeight: typographyV2.fontHeight.micro,
      headerFontSize: typographyV2.fontSize.micro,
      headerFontWeight: typographyV2.fontWeight.regular,
      headerHeight: '4.8rem',
      headerTextTransform: 'uppercase',
      rowBackground: colors.neutralColorHighLight,
      rowBorderColor: colors.neutralColorHighLight,
      rowBorderTopColor: colors.neutralColorLowLight,
      rowBorderWidth: borderV2.radius.nano,
      rowDisabledColor: colors.neutralColorLowMedium,
      rowHeight: '7.2rem',
      rowHoverBackground: colors.neutralColorHighMedium,
      shadow: '',
    },
    tooltip: {
      arrayItemMarginButtom: layoutV2.spacing.none,
      arrowBoxShadow: '',
      arrowSize: '0.5rem',
      backgroundColor: '#28292e',
      borderRadius: borderV2.radius.micro,
      boxShadow: '',
      color: colors.neutralColorHighPure,
      fontSize: typographyV2.fontSize.micro,
      fontWeight: typographyV2.fontWeight.semiBold,
      lineHeight: typographyV2.fontHeight.micro,
      margin: layoutV2.spacing.xmc,
      padding: `${layoutV2.spacing.xmc}`,
      textAlign: 'center',
      width: 'max-content',
    },
    upperMenu: {
      activeBackgroundColor: colorsV2.white,
      activeBorderBottomColor: colors.brandColorPrimaryPure,
      activeColor: colors.brandColorPrimaryPure,
      borderBottomColor: colors.neutralColorLowLight,
      borderBottomWidth: '0.2rem',
      borderLeftColor: '',
      borderLeftWidth: '',
      borderRadius: '',
      borderRightColor: '',
      borderRightWidth: '',
      borderTopColor: '',
      borderTopWidth: '',
      color: colors.neutralColorLowPure,
      fontWeight: '600',
      hoverBackgroundColor: '',
      hoverColor: colors.brandColorPrimaryPure,
      negativeBorderBottomColor: colors.feedbackColorNegativePure,
      negativeColor: colors.neutralColorLowPure,
    },
    tag: {
      borderRadius: borderV2.radius.display,
      fontWeight: typographyV2.fontWeight.semiBold,
      lineHeight: '1rem',
      gap: '0 0.6rem',
      fontSize: typographyV2.fontSize.small,
      padding: `${layoutV2.spacing.xxmc} ${layoutV2.spacing.micro}`,
      iconSize: '',
      positiveBorderColor: colors.feedbackColorPositivePure,
      positiveBackgroundColor: colors.feedbackColorPositivePure,
      positiveIconColor: colorsV2.white,
      positiveColor: colorsV2.white,
      negativeBorderColor: colors.feedbackColorNegativePure,
      negativeBackgroundColor: colors.feedbackColorNegativePure,
      negativeColor: colors.neutralColorHighPure,
      negativeIconColor: colorsV2.white,
      disabledBorderColor: colors.neutralColorLowLight,
      disabledBackgroundColor: colors.neutralColorHighLight,
      disabledColor: colors.neutralColorLowMedium,
      disabledIconColor: colors.neutralColorLowMedium,
      activeBorderColor: colors.neutralColorLowPure,
      activeBackgroundColor: colors.neutralColorLowPure,
      activeColor: colors.neutralColorHighPure,
      activeIconColor: colorsV2.white,
      enabledBorderColor: colors.neutralColorLowLight,
      enabledBackgroundColor: colors.neutralColorHighPure,
      enabledColor: colors.neutralColorLowPure,
      enabledIconColor: colors.neutralColorLowPure,
    },
    collapse: {
      fontSize: typography.fontSize.fontSizeXxs,
      fontWeight: typography.fontWeight.fontWeightRegular,
      borderRadius: border.radius.radiusSm,
      padding: layout.padding.spacingInsetXs,
      borderWidth: border.width.widthHairline,
      openBorderColor: '',
      borderColor: colors.neutralColorHighDark,
      openBackgroundColor: '',
      backgroundColor: 'transparent',
      openColor: '',
      color: colors.neutralColorLowPure,
      openIconColor: '',
      iconColor: colors.neutralColorLowDark,
    },
    card: {
      primaryFocusOutline: `${border.width.widthThin} solid ${colors.neutralColorLowPure}`,
    },
    phoneInput: {
      borderColor: colors.neutralColorLowLight,
      borderRadius: border.radius.radiusSm,
      borderWidth: borderV2.width.micro,
      ddiOptionMarginBottom: layoutV2.spacing.xmc,
      flagBorderRadius: borderV2.width.micro,
      fontSize: typography.fontSize.fontSizeXxs,
      lineHeight: '2.4rem',
      marginBottom: layoutV2.spacing.xs,
      marginTop: layoutV2.spacing.xmc,
      padding: layoutV2.spacing.xmc,
    },
    datePicker: {
      calendarBorderRadius: borderV2.radius.medium,
      calendarBorderColor: colors.neutralColorLowLight,
      calendarHeaderFontSize: '1.4rem',
      calendarHeaderFontWeight: typographyV2.fontWeight.semiBold,
      calendarWeekFontSize: typographyV2.fontSize.micro,
      calendarHeaderDayFontSize: typographyV2.fontSize.micro,
      calendarSelectedDayBackgroundColor: colors.neutralColorHighDark,
      calendarSelectedDayColor: colors.neutralColorLowPure,
      calendarSelectedDayFontWeight: typographyV2.fontWeight.semiBold,
      calendarCurrentDayColor: colors.brandColorPrimaryPure,
      calendarDayFontSize: typographyV2.fontSize.micro,
      borderRadius: borderV2.radius.medium,
      border: `0.2rem solid ${colors.neutralColorLowLight}`,
      placeholderColor: colors.neutralColorLowMedium,
    },
  },
}
